{
  "page": {
    "title": "ช่วยเหลือ",
    "intro": "คู่มือสั้นของงานหลัก และความหมายของคำเรื่องภาษีและกฎหมาย",
    "guides": "คู่มือ 30 วินาที",
    "topics": "คำนี้แปลว่าอะไร?",
    "back": "ช่วยเหลือทั้งหมด",
    "not_found": "ไม่มีหน้าช่วยเหลือนี้",
    "english_only": "หน้านี้ยังไม่มีภาษาไทย — แสดงเป็นภาษาอังกฤษ",
    "tour_again": "ดูการแนะนำหน้าแรกอีกครั้ง",
    "checklist_again": "แสดง “เตรียมร้านให้พร้อม” บนหน้าแรกอีกครั้ง",
    "checklist_shown": "รายการกลับมาอยู่บนหน้าแรกแล้ว",
    "tour_reset": "การแนะนำจะเริ่มเมื่อเปิดหน้าแรกครั้งถัดไป",
    "tools": "เครื่องมือช่วยเหลือ",
    "open_guide": "คู่มือของหน้านี้"
  },
  "checklist": {
    "title": "เตรียมร้านให้พร้อม",
    "intro": "ตั้งค่าครั้งเดียว แต่ละข้อเป็นสีเขียวเองเมื่อเสร็จแล้ว",
    "progress": "เสร็จ {{done}} จาก {{total}}",
    "hide": "ซ่อนรายการนี้",
    "hidden": "ซ่อนรายการแล้ว ไปที่ ช่วยเหลือ → “แสดง เตรียมร้านให้พร้อม” เพื่อเปิดอีกครั้ง",
    "all_done": "ร้านพร้อมแล้ว ซ่อนรายการนี้ได้",
    "go": "ตั้งค่า",
    "open": "เปิด",
    "status": {
      "done": "เสร็จแล้ว",
      "todo": "ยังไม่ได้ทำ",
      "unknown": "ตรวจไม่ได้",
      "no_access": "ให้เจ้าของร้านทำ"
    },
    "items": {
      "store": {
        "title": "ข้อมูลร้าน",
        "body": "ชื่อ ที่อยู่ โทรศัพท์ อีเมล — ใช้ในหน้าประกาศตามกฎหมายและอีเมล โลโก้อยู่ในการออกแบบเว็บ"
      },
      "tokushoho": {
        "title": "หน้าประกาศตามกฎหมาย (特商法表記)",
        "body": "14 ข้อ ครบเมื่อกรอกทุกข้อ (ตอนนี้ {{percent}}%)"
      },
      "tax": {
        "title": "ภาษี: เลขทะเบียน และการขายไปต่างประเทศ",
        "body": "เลข T และวิธีแสดงราคาต่างประเทศ"
      },
      "payments": {
        "title": "วิธีรับเงิน: บัญชีรับโอน และเครื่องรูดบัตร",
        "body": "บัญชีที่ลูกค้าโอนเข้า และเครื่องรูดบัตรพร้อม % ค่าธรรมเนียม"
      },
      "shipping": {
        "title": "ค่าส่ง: ในญี่ปุ่นและต่างประเทศ",
        "body": "วิธีส่งในญี่ปุ่นอย่างน้อย 1 และไปต่างประเทศอย่างน้อย 1"
      },
      "register": {
        "title": "เครื่องขายหน้าร้าน",
        "body": "เครื่องขาย 1 เครื่อง จับคู่กับแท็บเล็ตแล้ว"
      },
      "first_card": {
        "title": "การ์ดใบแรก",
        "body": "ลงการ์ดในราว 2 นาที"
      },
      "staff": {
        "title": "พนักงาน",
        "body": "เพิ่มคนที่ทำงานด้วย แต่ละคนมีชื่อเข้าระบบของตัวเอง"
      },
      "two_step": {
        "title": "ยืนยันตัวตน 2 ขั้นของคุณ",
        "body": "ใส่รหัสจากแอปในมือถือทุกครั้งที่เข้าระบบ เพื่อความปลอดภัยของร้าน"
      }
    }
  },
  "coach": {
    "label": "แนะนำหน้าแรก",
    "step": "{{n}} จาก {{total}}",
    "next": "ถัดไป",
    "done": "เข้าใจแล้ว",
    "skip": "ข้ามการแนะนำ",
    "list_title": "3 เรื่องที่ควรรู้",
    "big_actions": {
      "title": "ปุ่มใหญ่",
      "body": "งานประจำวัน: ลงการ์ด ออเดอร์ที่ต้องส่ง รับของฝากขาย เปิดเครื่องขาย"
    },
    "search": {
      "title": "ค้นหาทุกอย่าง",
      "body": "พิมพ์ชื่อการ์ด เลขออเดอร์ หรือสแกนโค้ด ถ้าใช้คีย์บอร์ด: Ctrl + K"
    },
    "inbox": {
      "title": "รายการที่ต้องทำ",
      "body": "กระดิ่งแสดงสิ่งที่รอคุณ: ตรวจโอนเงิน ออเดอร์ที่ต้องส่ง ปัญหา สีแดง = ด่วน"
    }
  },
  "feedback": {
    "button": "แจ้งปัญหา/ข้อเสนอ",
    "title": "บอกเราเรื่องปัญหาหรือข้อเสนอ",
    "kind": "เป็นเรื่องอะไร?",
    "kind_problem": "มีอะไรใช้ไม่ได้",
    "kind_idea": "ไอเดียให้ใช้ง่ายขึ้น",
    "message": "เกิดอะไรขึ้น หรืออะไรจะช่วยได้?",
    "message_hint": "อย่าพิมพ์ชื่อ ที่อยู่ หรือเลขบัตรของลูกค้า",
    "message_required": "พิมพ์สักนิดก่อน",
    "attached": "ส่งไปด้วย: หน้านี้ เวลา และเลขอ้างอิงของปัญหาล่าสุด ({{requestId}})",
    "attached_none": "ส่งไปด้วย: หน้านี้และเวลา",
    "send": "ส่ง",
    "sent": "ขอบคุณ — ส่งแล้ว",
    "email_instead": "ส่งทางอีเมลแทน",
    "no_channel": "ยังส่งจากที่นี่ไม่ได้ ใช้อีเมล:",
    "failed": "ส่งไม่ได้ ลองอีกครั้ง หรือใช้อีเมล"
  },
  "usability": {
    "title": "ทดสอบความง่าย (สำหรับผู้สังเกต)",
    "panel": "แผงทดสอบความง่าย (ผู้สังเกตเท่านั้น)",
    "start": "เริ่มงานที่ {{n}}",
    "done": "ทำเสร็จ",
    "gave_up": "ยอมแพ้",
    "download_other": "ดาวน์โหลดผล ({{count}} งาน)"
  }
}
